<template>
<div class="chapter">
<div class="inner_page">
<p class="autor" id="jump_to_top">Edgar Wallace</p>
<p class="titel">Der Zinker</p>
<p class="autor"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title_page.vue?f1134f96